module.exports = __webpack_public_path__ + "img/AI_huha1.fdf5535e.png";